import { yetkiliMi } from "./yetki.js";
import { K28_TARIH_KURALLARI } from "./is-tarihi.js";
import { UYARI_KALIPLARI } from "./belgeler.js";
/* ====================================================================================================================
 * 1 · Okuma durumları ve okunan değer
 * ================================================================================================================== */
/** `belge_gelen.okuma_durumu` (B1). Boş = okunmamış. Yalnız açık satırda yazılır. */
export const OKUMA_DURUMLARI = ["sirada", "okunuyor", "okundu", "okunamadi", "riser_bekliyor", "adim_bekliyor", "yer_bekliyor"];
export const okumaDurumuMu = (x) => typeof x === "string" && OKUMA_DURUMLARI.includes(x);
/** Okuma bitince açık satırın alabileceği durumlar (`okumaBitir`). */
export const OKUMA_SONU_DURUMLARI = ["okundu", "riser_bekliyor", "adim_bekliyor", "yer_bekliyor"];
/** `belge_okuma.kaynak`: motor (zamanlanmış görev) · elle ("File by hand"dan sonra) · denetim (K19, yalnız uyarı; kayıt değişmez). */
export const OKUMA_KAYNAKLARI = ["motor", "elle", "denetim"];
/** `belge_okuma.sonuc`. */
export const OKUMA_SONUCLARI = ["okunuyor", "okundu", "okunamadi"];
/** Değerin kesinliği (K5, plan §4.0): kesin (yeşil) · suphe (sarı; kişi onaylar) · bos (okunamadı). */
export const KESINLIKLER = ["kesin", "suphe", "bos"];
/** Yerin kaynağı (P:1092): ekran (kısa yol) · oneri (OASIS) · kisi ("Change owner", "Choose owner") · dosyalanmis · yeniden_eslesme (K30). */
export const YER_KAYNAKLARI = ["ekran", "oneri", "kisi", "dosyalanmis", "yeniden_eslesme"];
/** Açılan dosya kanıttaki dosya değilse (baytlar değişti) true; ekran uyarır (P:1007). */
export const kanitDegistiMi = (k, sha256) => k.sha256 !== sha256;
/* ====================================================================================================================
 * 2 · Uyarı kodları
 * ================================================================================================================== */
/**
 * Planın §6 uyarı kümesi (141 kod: 22 kırmızı, 82 sarı, 37 gri; P:1404) ve renkleri. Renk kodun özelliğidir: OASIS verir, motor vermez
 * (plan §4.0). Bugün üretilen kodlar yalnız FAZ1_UYARI_KODLARI'dır (belgeler.ts); öteki kodları kendi okuyucu PR'ı üretir.
 */
export const UYARI_KODLARI = {
    "GEN-01": "gri", "GEN-02": "kirmizi", "GEN-03": "sari", "GEN-04": "gri", "GEN-05": "gri", "GEN-06": "sari", "GEN-07": "gri", "GEN-08": "gri", "GEN-09": "gri", "GEN-10": "sari", "GEN-11": "gri", "GEN-12": "gri", "GEN-13": "sari", "GEN-14": "sari", "GEN-15": "sari", "GEN-16": "kirmizi", "GEN-17": "sari", "GEN-18": "sari", "GEN-19": "sari", "GEN-20": "sari", "GEN-21": "sari", "GEN-22": "gri",
    "KIM-01": "kirmizi", "KIM-02": "kirmizi", "KIM-03": "gri", "KIM-04": "sari", "KIM-05": "sari", "KIM-06": "gri", "KIM-07": "sari", "KIM-08": "sari",
    "KAL-01": "kirmizi", "KAL-02": "kirmizi", "KAL-03": "sari", "KAL-04": "sari", "KAL-05": "sari", "KAL-06": "sari", "KAL-07": "gri", "KAL-08": "sari", "KAL-09": "sari", "KAL-10": "kirmizi",
    "TES-01": "kirmizi", "TES-02": "kirmizi", "TES-03": "sari", "TES-04": "sari", "TES-05": "sari", "TES-06": "gri", "TES-07": "gri",
    "MTL-01": "kirmizi", "MTL-02": "gri", "MTL-03": "sari", "MTL-04": "sari", "MTL-05": "sari", "MTL-06": "kirmizi", "MTL-07": "sari", "MTL-08": "sari", "MTL-09": "sari",
    "COC-01": "sari", "COC-02": "gri", "COC-03": "gri",
    "PO-01": "sari", "PO-02": "sari", "PO-03": "gri", "PO-04": "gri",
    "NDT-01": "sari", "NDT-02": "sari", "NDT-03": "sari", "NDT-04": "sari", "NDT-05": "sari", "NDT-06": "sari", "NDT-07": "gri", "NDT-08": "gri", "NDT-09": "kirmizi",
    "WPQ-01": "sari", "WPQ-02": "sari", "WPQ-03": "sari", "WPQ-04": "gri", "WPQ-05": "sari", "WPQ-06": "sari", "WPQ-07": "gri", "WPQ-08": "sari",
    "SARF-01": "kirmizi", "SARF-02": "kirmizi", "SARF-03": "sari", "SARF-04": "sari", "SARF-05": "sari", "SARF-06": "sari",
    "WPS-01": "kirmizi", "WPS-02": "sari", "WPS-03": "kirmizi", "WPS-04": "sari", "WPS-05": "gri", "WPS-06": "sari", "WPS-07": "gri",
    "HT-01": "kirmizi", "HT-02": "sari", "HT-03": "kirmizi", "HT-04": "kirmizi", "HT-05": "kirmizi", "HT-06": "sari", "HT-07": "sari", "HT-08": "sari", "HT-09": "gri", "HT-10": "sari", "HT-11": "gri", "HT-12": "gri", "HT-13": "gri", "HT-14": "kirmizi",
    "NR-01": "sari", "NR-02": "sari", "NR-03": "sari", "NR-04": "sari", "NR-05": "sari", "NR-06": "sari", "NR-07": "sari", "NR-08": "gri", "NR-09": "gri",
    "WM-01": "sari", "WM-02": "sari", "WM-03": "sari", "WM-04": "sari", "WM-05": "sari", "WM-06": "sari", "WM-07": "sari", "WM-08": "sari",
    "PW-01": "sari", "PW-02": "gri", "PW-03": "gri", "PW-04": "gri", "PW-05": "sari",
    "BY-01": "sari", "BY-02": "sari", "BY-03": "gri", "BY-04": "gri", "BY-05": "sari", "BY-06": "sari", "BY-07": "sari",
    "PB-01": "kirmizi", "PB-02": "sari", "PB-03": "sari", "PB-04": "gri", "PB-05": "sari",
};
export const uyariKoduMu = (x) => typeof x === "string" && Object.hasOwn(UYARI_KODLARI, x);
/**
 * Bekir'in değerini ya da listesini bekleyen kurallar: saklanamaz, dolayısıyla hiçbir ekrana çıkamaz (harita §2 güvenli varsayılanları).
 * Değer karar kimliğidir. Açmak bu listeden çıkarmayı ister.
 * D-074 Faz 2 · PR 10: WPQ-03 (çap, kalınlık, pozisyon kuralı) ve WPS-07 (bilinen baskı hataları listesi).
 * D-074 Faz 3 · PR 15: WPQ-03 açıldı (proses ve WPS kısmı, weld map); çap, kalınlık, pozisyon ve backing kısmı kod değil not olarak kapalı.
 */
export const KAPALI_UYARI_KODLARI = {
    "HT-01": "K6", "HT-06": "K8", "KAL-03": "K11", "MTL-07": "K14", "GEN-06": "K15", "BY-01": "K17", "BY-05": "BY-05", "MTL-05": "MTL-05", "WPQ-07": "K27",
    "WPS-07": "WPS-07",
    ...Object.fromEntries(K28_TARIH_KURALLARI.map((k) => [k, "K28"])),
};
export const uyariKapaliMi = (kod) => Object.hasOwn(KAPALI_UYARI_KODLARI, kod);
/** Kimlik kararları (K35, plan §5.7): yetki `belgeKimlikKarari`. */
export const KIMLIK_KARAR_KODLARI = ["KIM-01", "KIM-02", "PB-01"];
/* ====================================================================================================================
 * 3 · Karar
 * ================================================================================================================== */
/**
 * Karar seçenekleri (plan §5.3, §5.13, §5.14, §5.15). Ekran adları (İngilizce, karar ekranı PR'ında sözlüğe girer):
 * dosyala "File anyway" · dosyalama "Do not file" · yer_degistir "Change owner" · hatta_dosyala "File to a line" · risere_tasi "Move to riser {0}" ·
 * buraya "File here" · kopya_reddet "Reject as copy of {0}" · burada_kalsin "Keep here" · referans_isaretle "Mark as reference" ·
 * kopya_isaretle "Mark as copy of {0}" · sayfalari_disla "Exclude these pages" · riser_raporuna_bagla "Reference to riser {0}'s own report" ·
 * datapack_reddet "Reject datapack" · referans "File as reference" · reddet "Reject" · incelendi "Mark reviewed" ·
 * goruldu "Mark seen" (yalnız denetim bulgusu; Documents'ın seçeneklerinde yoktur, D-074 Faz 2 · PR 12).
 * Bu PR yalnız kaydı yazar; seçeneğin etkisi (dosyalama, taşıma, kopya) karar ekranı PR'larındadır. D-074 Faz 2 · PR 8: tek etkisi Documents'tan
 * dosyalamanın kapısıdır (`dosyalamaEngeli`); ekran adları KARAR_SECENEK_ADI'nda.
 */
export const KARAR_SECENEKLERI = [
    "dosyala", "dosyalama", "yer_degistir", "hatta_dosyala", "risere_tasi", "buraya", "kopya_reddet", "burada_kalsin", "referans_isaretle",
    "kopya_isaretle", "sayfalari_disla", "riser_raporuna_bagla", "datapack_reddet", "referans", "reddet", "incelendi", "goruldu",
];
/** Kırmızı kararın gerekçesi (K35; biri zorunlu): "Misprint on the document" · "Stamp on the part differs" · "MRB value suspected" · "Line replaced or from another riser" · "Other". */
export const KARAR_GEREKCELERI = ["yazim_hatasi", "damga_farkli", "mrb_suphe", "hat_degisti", "diger"];
/** "Remember for this line" varsayılanı (plan §5.14 tasarım ayrıntısı 1): yazım hatası belgeye aittir, hatırlanmaz. */
export const hatirlaVarsayilan = (g) => g !== "yazim_hatasi";
/** Uyarıya kim karar verir: kimlik kararları `belgeKimlikKarari`, ötekiler `belgeUyari` (K3, K35; PM ve sistem yöneticisi her zaman). Saha inspektörü vermez. */
export function kararVerebilirMi(rol, kod) {
    return yetkiliMi(rol, KIMLIK_KARAR_KODLARI.includes(kod) ? "belgeKimlikKarari" : "belgeUyari");
}
/** D-074 Faz 2 · PR 8: kararın ekran adı (olay metni ve kart; sözlükte). */
export const KARAR_SECENEK_ADI = {
    dosyala: "File anyway", dosyalama: "Do not file", yer_degistir: "Change owner", hatta_dosyala: "File to a line", risere_tasi: "Move to riser {0}",
    buraya: "File here", kopya_reddet: "Reject as copy of {0}", burada_kalsin: "Keep here", referans_isaretle: "Mark as reference",
    kopya_isaretle: "Mark as copy of {0}", sayfalari_disla: "Exclude these pages", riser_raporuna_bagla: "Reference to riser {0}'s own report",
    datapack_reddet: "Reject datapack", referans: "File as reference", reddet: "Reject", incelendi: "Mark reviewed", goruldu: "Mark seen",
};
/** D-074 Faz 2 · PR 8: K35 gerekçelerinin ekran adı. */
export const KARAR_GEREKCE_ADI = {
    yazim_hatasi: "Misprint on the document", damga_farkli: "Stamp on the part differs", mrb_suphe: "MRB value suspected",
    hat_degisti: "Line replaced or from another riser", diger: "Other",
};
/**
 * D-074 Faz 2 · PR 8 (T19): uyarıya sunulan seçenekler. KIM-01 "File here" / "Do not file"; KIM-02 "File to a line" / "Do not file"; öteki
 * kırmızılar "File anyway" / "Do not file"; sarı "Mark reviewed"; gri yok (yalnız gösterilir). "Move to riser", "Reject as copy" bu PR'da yok.
 */
export function uyariSecenekleri(kod, renk) {
    if (renk === "kirmizi") {
        // D-074 Faz 5 · PR 26 (K40): PB-01 'Exclude these pages' / 'Reference to riser {0}'s own report' / 'Reject datapack'; 'Move' yok.
        if (kod === "PB-01")
            return ["sayfalari_disla", "riser_raporuna_bagla", "datapack_reddet"];
        if (kod === "KIM-01")
            return ["buraya", "dosyalama"];
        if (kod === "KIM-02")
            return ["hatta_dosyala", "dosyalama"];
        return ["dosyala", "dosyalama"];
    }
    return renk === "sari" ? ["incelendi"] : [];
}
/** T21: sertifika "Rejected" dosyalanırken kapıyı kapatmayan kırmızılar (test kusurları; kimlik ve kopya kırmızıları kapatır). */
export const RETTE_SERBEST_KODLAR = ["HT-03", "HT-04", "HT-05", "HT-14"];
/**
 * T21 (K1): Documents'tan dosyalamanın kapısı. Önce herhangi bir "Do not file" kararı → "dosyalama"; sonra kararsız kırmızılardan (`ret` ise
 * RETTE_SERBEST_KODLAR hariç) biri varsa → "kirmizi"; yoksa null. `uyarilar` etkin okumanın uyarıları ve kararlarıdır. Karar kayıttır; hiçbir
 * kaydı değiştirmez. "File as reference", "Reject" ve Finishing'in kendi yükleme yolu bu kapıya bakmaz.
 */
export function dosyalamaEngeli(uyarilar, ret) {
    // D-074 Faz 5 · PR 26: 'Reject datapack' de 'Do not file' gibi kapatır.
    if (uyarilar.some((u) => u.karar?.secenek === "dosyalama" || u.karar?.secenek === "datapack_reddet"))
        return "dosyalama";
    const serbest = (kod) => ret && RETTE_SERBEST_KODLAR.includes(kod);
    return uyarilar.some((u) => u.renk === "kirmizi" && !u.karar && !serbest(u.kod)) ? "kirmizi" : null;
}
export const DOSYALAMA_ENGEL_METNI = {
    kirmizi: "Red alerts wait for a decision by the Quality Lead or the PM. Filing opens after the decision; File as reference and Reject stay open.",
    dosyalama: "Decided: do not file. Reject the upload or file it as reference.",
};
/**
 * T3, T16 kapısı (inceleme bulgusu): hidrotest sertifikası yalnız güncel okumasının karşılaştırıldığı yere dosyalanır. Okuma hiç
 * karşılaştırılmadıysa (PR 8'den önceki okuma) ya da başka bir yer için karşılaştırıldıysa Documents'tan dosyalanmaz; kartın yeri kaydedilince
 * kendiliğinden, ya da "Compare again" ile yeniden karşılaştırılır. Ret ve referans yolu ile Finishing'in kendi yolu bu kapıya bakmaz.
 */
export const KARSILASTIRMA_YERI_METNI = "The reading is not compared for this place yet. Wait for the comparison or use Compare again, then file.";
/* ====================================================================================================================
 * 4 · Kör yazma ve GEN-19
 * ================================================================================================================== */
/** Kör yazma karşılaştırmasının biçimi (B11): kenar boşlukları atılır, iç boşluklar teke iner, harf büyüklüğü yok sayılır. Başka dönüşüm yok. */
export const korNormal = (s) => s.trim().replace(/\s+/g, " ").toLocaleUpperCase("en");
/** "Type what you read" sonucu: kişinin yazdığı okunanla aynıysa "tuttu", değilse (ya da biri boşsa) "bos" (alan boş kalır, GEN-19). */
export function korYazmaSonucu(okunan, yazilan) {
    if (!okunan || !yazilan || !korNormal(okunan) || !korNormal(yazilan))
        return "bos";
    return korNormal(okunan) === korNormal(yazilan) ? "tuttu" : "bos";
}
/** GEN-19 uyarısının girdisi (alan adı). */
export const gen19 = (alan) => ({ kod: "GEN-19", kalip: UYARI_KALIPLARI["GEN-19"], degerler: [alan] });
/** Okunamayan (kesinliği "bos") her değer için GEN-19 (plan GEN-19 "değer okunamadı"). Sıra değerlerin sırası; aynı alan bir kez. */
export function bosDegerUyarilari(degerler) {
    const alanlar = new Set();
    for (const d of degerler)
        if (d.kesinlik === "bos")
            alanlar.add(d.alan);
    return [...alanlar].map(gen19);
}
/**
 * D-074 Faz 2 · PR 9b: kartta okunan değerlerin sırası. `sira`daki alanlar o sırayla; sırada olmayan alanlar (beklenmez) sonda, kayıttaki sırayla.
 * Kayıtta olmayan alan için satır yoktur: sürüm 2 okumasında eski alanlar görünmez, sürüm 1 okumasında hepsi görünür.
 */
export function kartSirasiyla(degerler, sira) {
    const yer = new Map(sira.map((a, i) => [a, i]));
    const konum = (d, i) => yer.get(d.alan) ?? sira.length + i;
    return degerler.map((d, i) => ({ d, k: konum(d, i) })).sort((a, b) => a.k - b.k).map((x) => x.d);
}
/* ====================================================================================================================
 * 5 · Doğrulama ve güncel okuma
 * ================================================================================================================== */
const sonluMu = (x) => typeof x === "number" && Number.isFinite(x);
/** Sayfa yeri geçerli mi: dört alan sonlu sayı, 0 ≤ sol, ust; genislik, yukseklik > 0; sol + genislik ≤ 1; ust + yukseklik ≤ 1. */
export function sayfaYeriMi(x) {
    if (!x || typeof x !== "object")
        return false;
    const { sol, ust, genislik, yukseklik } = x;
    if (!sonluMu(sol) || !sonluMu(ust) || !sonluMu(genislik) || !sonluMu(yukseklik))
        return false;
    return sol >= 0 && ust >= 0 && genislik > 0 && yukseklik > 0 && sol + genislik <= 1 && ust + yukseklik <= 1;
}
/** Okunan değerin alan adı ve metin sınırları. */
const ALAN_ADI = /^[a-z][a-z0-9_]*$/;
const ALAN_EN_COK = 80;
const DEGER_EN_COK = 500;
/**
 * Okunan değerin hatası (İngilizce, sunucu 400 olarak döner) ya da null. `sayfaSayisi` bilinmiyorsa (null) sayfa üst sınırı denetlenmez.
 * Kurallar: nesne; `alan` boş olmayan, en çok 80 karakter, /^[a-z][a-z0-9_]*$/; `deger` ve `yazildigi` metin ya da null, en çok 500
 * karakter; `kesinlik` KESINLIKLER'den; `deger` null ⇔ `kesinlik` "bos"; `sayfa` null ya da 1..sayfaSayisi tamsayı; `yer` null ya da
 * sayfaYeriMi (yer varsa sayfa da olmalı); `kimlik` boolean.
 */
export function okunanDegerHatasi(d, sayfaSayisi) {
    if (!d || typeof d !== "object" || Array.isArray(d))
        return "Invalid read value.";
    const o = d;
    const alan = typeof o.alan === "string" ? o.alan : "";
    if (!alan || alan.length > ALAN_EN_COK || !ALAN_ADI.test(alan))
        return `Invalid read value: ${alan} (field name).`;
    if (!KESINLIKLER.includes(o.kesinlik))
        return `Invalid read value: ${alan} (certainty).`;
    const metinMi = (x) => x === null || typeof x === "string";
    if (!metinMi(o.deger) || !metinMi(o.yazildigi) || (o.deger === null) !== (o.kesinlik === "bos"))
        return `Invalid read value: ${alan} (an empty value must be marked empty).`;
    if (o.sayfa !== null && (!Number.isInteger(o.sayfa) || o.sayfa < 1 || (sayfaSayisi !== null && o.sayfa > sayfaSayisi)))
        return `Invalid read value: ${alan} (page).`;
    if (o.yer !== null && (!sayfaYeriMi(o.yer) || o.sayfa === null))
        return `Invalid read value: ${alan} (place on the page).`;
    if ((o.deger?.length ?? 0) > DEGER_EN_COK || (o.yazildigi?.length ?? 0) > DEGER_EN_COK)
        return `Invalid read value: ${alan} (text too long).`;
    if (typeof o.kimlik !== "boolean")
        return `Invalid read value: ${alan} (identity flag).`;
    return null;
}
/**
 * Her gelen satırının güncel okuması: `sonuc = okundu` olan en yeni (ts, eşitlikte id büyük olan). Girdi sırası önemsiz; `sonuc`
 * verilmişse "okundu" olmayanlar atlanır (verilmemişse çağıran yalnız okunmuşları verir).
 */
export function guncelOkumalar(okumalar) {
    const enYeni = new Map();
    for (const o of okumalar) {
        if (!o.gelenId || (o.sonuc !== undefined && o.sonuc !== "okundu"))
            continue;
        const t = new Date(o.ts).getTime();
        const once = enYeni.get(o.gelenId);
        if (!once || t > once.t || (t === once.t && o.id > once.id))
            enYeni.set(o.gelenId, { id: o.id, t });
    }
    return new Map([...enYeni].map(([g, o]) => [g, o.id]));
}
/* ====================================================================================================================
 * 6 · Görüntüleyici (K37, plan P:994-1010)
 * ================================================================================================================== */
/** Tarayıcının kendisinin gösterdiği resim türleri. HEIC ve TIFF gösterilemez: görüntüleyici dosyanın tamamını ve indirmeyi verir. */
export const GORSEL_MIMELERI = ["image/jpeg", "image/png", "image/gif", "image/webp"];
const GORSEL_UZANTISI = /\.(?:jpe?g|png|gif|webp)$/i;
/** Dosya görüntüleyicide resim olarak açılır mı. MIME boş ya da "application/octet-stream" ise ad uzantısına bakılır. */
export function gorselMi(mime, ad) {
    const m = (mime ?? "").split(";")[0].trim().toLowerCase();
    if (GORSEL_MIMELERI.includes(m))
        return true;
    return (m === "" || m === "application/octet-stream") && GORSEL_UZANTISI.test(ad ?? "");
}
//# sourceMappingURL=belge-okuma.js.map